import { h, render } from 'preact';
import Grossiers from "./components/Grossiers";

function main() {
  render(<Grossiers />, document.querySelector('#root'));
}

main()
